import { render, staticRenderFns } from "./SubtitlePlayer.vue?vue&type=template&id=0f8eeef8&scoped=true"
import script from "./SubtitlePlayer.vue?vue&type=script&lang=ts"
export * from "./SubtitlePlayer.vue?vue&type=script&lang=ts"
import style0 from "./SubtitlePlayer.vue?vue&type=style&index=0&id=0f8eeef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8eeef8",
  null
  
)

export default component.exports